import { render, staticRenderFns } from "./OCRStep.vue?vue&type=template&id=dddbffd0"
import script from "./OCRStep.vue?vue&type=script&lang=js"
export * from "./OCRStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports